import React from "react";
import { Box, Checkbox } from "@mui/material";

const ResourceSelectCell = ({ 
  resourceId, 
  selectedResources, 
  onSelect, 
  disabled = false 
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Checkbox
        checked={selectedResources.includes(resourceId)}
        onChange={() => onSelect(resourceId)}
        disabled={disabled}
        sx={{ color: "#031B89", "&.Mui-checked": { color: "#031B89" } }}
      />
    </Box>
  );
};

export default ResourceSelectCell;

